module.exports = __webpack_public_path__ + "img/e18825d.jpg";